import { Theme, css } from '@emotion/react';

export const radioRoot = ({ colors }: Theme) => css`
  color: ${colors.textBase};
`;

export const formGroupRoot = ({ spacing }: Theme) => css`
  margin-bottom: ${spacing(1)}px;
  .MuiFormcontrolLabel-root {
    margin-left: -${spacing(1)}px;
  }
  .MuiIconButton-root {
    padding: 6px;
  }
`;

export const formLabelRoot = ({ font, colors, spacing }: Theme) => css`
  font-family: ${font.medium};
  font-size: 18px;
  line-height: 1.33;
  color: ${colors.textBase};
  margin-bottom: ${spacing(1)}px;
`;

export const formHelperTextRoot = () => css`
  margin-top: 0;
`;
